// src/auth/msal.js
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "3b0198ad-c517-462b-8688-a40de08cbfd9", // your SPA app registration
    authority: "https://login.microsoftonline.com/8fcf2988-0ea9-43cc-9e97-a59c6909e71c",
    redirectUri: "https://www.axillonaerospace.info", // must match Azure
  },
  cache: { cacheLocation: "sessionStorage" }, // or "localStorage"
};

export const API_SCOPE = "api://2ac1ef87-5c41-4370-ae95-33a4e4bc7f49/access_as_user";

// Microsoft Graph API scopes for SharePoint access
export const GRAPH_SCOPES = [
  "https://graph.microsoft.com/Sites.Read.All",
  "https://graph.microsoft.com/Files.ReadWrite.All",
];

export const msalInstance = new PublicClientApplication(msalConfig);